import './styles/app.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { config as zodConfig } from 'zod/v4/core';

import { meQuery } from './auth/session';
import { i18nReady } from './i18n';
import { branchesQuery } from './layout/TopBar';
import { createRouter } from './router';
import { watchClinicTheme } from './theme/theme';

// Sin el JIT de zod: prueba `new Function` y la CSP sin 'unsafe-eval' lo rechaza (ADR-106).
zodConfig({ jitless: true });

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });
const root = document.getElementById('root');
if (root === null) throw new Error('falta #root');

// RNF-PERF-01 (ADR-097): la sesión y las sucursales del shell salen junto con el chunk de la
// pantalla; si no, esperan a que React Router lo baje y cada una suma un viaje de red.
const PUBLIC = ['/login', '/forgot-password', '/reset-password', '/invite/', '/select-clinic'];
// Un error queda en la caché y la pantalla que usa la consulta la vuelve a pedir (sin sesión, las
// sucursales responden 401: no se reintentan acá).
const ignore = () => undefined;
// RF-AJU-10: el tema de la clínica sigue a la sesión.
watchClinicTheme(queryClient);
queryClient.query(meQuery).catch(ignore);
if (!PUBLIC.some((p) => window.location.pathname.startsWith(p)))
  queryClient.query({ ...branchesQuery, retry: false }).catch(ignore);

void i18nReady.then(() => {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={createRouter()} />
      </QueryClientProvider>
    </StrictMode>,
  );
});
